import { useEffect, useState, useRef } from "react";
import { matchRoutes } from "react-router-config";
import { withRouter } from "react-router-dom";
import { parse } from "query-string";

const buildQueries = (location, routes, modules) => {
    const branch = matchRoutes(routes, location.pathname);
    let routeQueries = [];
    let globalQueries = [];

    branch.forEach(({ route, match }) => {
        const componentQueries = route.component.queries || (() => []);
        const queryParams = parse(location.search) || {};
        const routeParams = match.params || {};
        const params = {
            ...queryParams,
            ...routeParams,
        };
        const branchQueries = ((route.queries && route.queries(params)) || []).filter(
            ({ downloadOnly }) => !downloadOnly,
        );
        const containerQueries = componentQueries(params, modules);
        if (branchQueries.length) {
            routeQueries.push(...branchQueries);
        }
        if (containerQueries.length) {
            globalQueries.push(...containerQueries);
        }
    });

    return [globalQueries, routeQueries];
};

const fetchData = (location, routes, dispatch, fetch, modules, refresh) => {
    const [globalQueries, routeQueries] = buildQueries(location, routes, modules);
    dispatch(fetch(globalQueries, refresh, true));
    dispatch(fetch(routeQueries, refresh, false));
    return Promise.resolve(null);
};

function DataLoader({ children, location, routes, dispatch, fetch, modules }) {
    const [readyPathname, setReadyPathname] = useState(location?.pathname);
    const prevRoutesRef = useRef(routes);
    const prevModulesRef = useRef(modules);
    const prevSearchRef = useRef(location?.search);

    useEffect(() => {
        const routesChanged = JSON.stringify(routes) !== JSON.stringify(prevRoutesRef.current);
        const modulesChanged = JSON.stringify(modules) !== JSON.stringify(prevModulesRef.current);
        const pathChanged = readyPathname !== location.pathname;
        const searchChanged = prevSearchRef.current !== location.search;

        if (pathChanged || routesChanged || modulesChanged) {
            fetchData(location, routes, dispatch, fetch, modules, false).then(() => {
                setReadyPathname(location.pathname);
            });
        } else if (searchChanged) {
            fetchData(location, routes, dispatch, fetch, modules, false);
        }

        prevRoutesRef.current = routes;
        prevModulesRef.current = modules;
        prevSearchRef.current = location.search;

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [dispatch, fetch, routes, modules, JSON.stringify(location)]);

    return (
        readyPathname === location.pathname &&
        children(() => {
            fetchData(location, routes, dispatch, fetch, modules, true);
        })
    );
}

export default withRouter(DataLoader);
